<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_ncNo') || 'NC编号'">
            <el-input
              v-model.trim="formData.ncNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_fabricIdentifyName') || '面料识别名称'"
            prop="fabricIdentifyName"
          >
            <el-input
              v-model="formData.fabricIdentifyName"
              readonly
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (chooseFabricDialogVisible = true)"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricPosition') || '面料位置'"
            prop="fabricPosition"
          >
            <dict-select
              v-model="formData.fabricPosition"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricPosition' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricWidth') || '面料门幅'"
            prop="fabricWidth"
          >
            <el-input-number
              v-model="formData.fabricWidth"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="999999.99"
              :step="1"
              :precision="2"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fabricUnit') || '面料单位'">
            <dict-select
              v-model="formData.fabricUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricYarnUnit' }"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricWeight') || '面料克重'"
            prop="fabricWeight"
          >
            <el-input-number
              v-model="formData.fabricWeight"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="999999.99"
              :step="1"
              :precision="2"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricWeightUnit') || '克重单位'"
            prop="fabricWeightUnit"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricWeightUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_qty') || '耗料'" prop="qty">
            <el-input-number
              v-model="formData.qty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.999"
              :step="1"
              :precision="3"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_unitPrice') || '单价'"
            prop="unitPrice"
          >
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.999"
              :step="1"
              :precision="3"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_subPrice') || '小计'">
            <el-input v-model="v_subPrice" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="'选择面料信息'"
      :visible.sync="chooseFabricDialogVisible"
      type="radio"
      @confirm="chooseFabricConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { multiplyRound, format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    pdCostsOrderGoodsSpecFabricCode: { type: String, default: '' },
    pdCostsOrderGoodsSpecCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      chooseFabricDialogVisible: false,
      rules: {
        fabricPosition: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricIdentifyName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
        fabricWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
        fabricWeightUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    subPrice() {
      const { qty, unitPrice } = this.formData
      return multiplyRound(qty, unitPrice)
    },
    v_subPrice() {
      return format(this.subPrice)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderGoodsSpecFabricCode) return
      const res = await this.$api
        .pdCostsOrderGoodsSpecFabricDetailApi({
          pdCostsOrderGoodsSpecFabricCode: this.pdCostsOrderGoodsSpecFabricCode,
        })
        .catch(() => null)
      if (!res) return
      const data = res.body
      let fabricWeight = 0
      let fabricWeightUnit = ''

      const { fabricWeight: v_weight } = data

      if (v_weight) {
        const index = v_weight.indexOf(' ')
        if (index >= 0) {
          fabricWeight = parseFloat(v_weight.substring(0, index))
          fabricWeightUnit = v_weight.substring(index + 1)
        }
      }

      this.formData = {
        ...data,
        fabricWeight,
        fabricWeightUnit,
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { fabricWeight, fabricWeightUnit } = this.formData
      const weight = `${fabricWeight} ${fabricWeightUnit}`

      this.loadingOpen()
      const res = await this.$api
        .pdCostsOrderGoodsSpecFabricSaveApi({
          ...this.formData,
          fabricWeight: weight,
          pdCostsOrderGoodsSpecCode: this.pdCostsOrderGoodsSpecCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    chooseFabricConfirm(data) {
      const {
        fabricCode,
        fabricName,
        fabricNameEn,
        fabricContent,
        fabricContentEn,
        fabricUnit,
        fabricWeight,
        fabricWeightUnit,
        wid,
      } = data

      const fabricIdentifyName = [fabricName, fabricContent]
        .filter(Boolean)
        .join(' ')

      this.formData = {
        ...this.formData,
        fabricCode,
        fabricName,
        fabricNameEn,
        fabricContent,
        fabricContentEn,
        fabricIdentifyName,
        fabricUnit,
        fabricWidth: wid,
        fabricWeight,
        fabricWeightUnit,
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
